export default "__VITE_ASSET__D6MR8NIl__"